export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9377.e1959109.jpg";